/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { Box, Flex, LegacyText, Divider } from "flicket-ui";

import { Footer, PageContainer } from "~components";
import {
  isCompetitionPageContext,
  PageContext,
} from "~features/events/hooks/useDetailsPageContext";
import useShowReleaseCodes from "~features/events/hooks/useShowReleaseCodes";
import { LandingPage } from "~graphql/sdk";
import { useOrganization } from "~hooks";
import CompetitionDetails from "../CompetitionDetails/CompetitionDetails";
import BackLink from "../events.BackLink";
import { CTACard } from "../events.CTACard";
import EventInformation, { EventSummary } from "../events.EventInformation";
import Section from "../events.Section";
import CompetitionCardFooter from "../CompetitionDetails/CompetitionCardFooter";

export type DesktopDetailProps = {
  isSinglePage: boolean;
  pageContext: PageContext;
};

export const Desktop = ({ pageContext, isSinglePage }: DesktopDetailProps) => {
  const {
    title,
    logo,
    backgroundImage,
    backgroundImageFullPage,
    season,
    enableReleaseCodes,
  } = pageContext.event;

  const event = pageContext.event;
  const { organization, hasFeature } = useOrganization();

  const showReleaseCodes = useShowReleaseCodes(enableReleaseCodes);

  const calendarView = hasFeature("eventCalendarHomepage");

  return (
    <>
      <PageContainer
        backgroundImage={backgroundImage}
        backgroundImageFullPage={backgroundImageFullPage}
        bannerImage={logo}
        titleText={title}
        footer={<Footer />}
      >
        {!calendarView && (
          <BackLink
            isSinglePage={isSinglePage}
            tourId={
              organization.landingPage === LandingPage.Tours && season
                ? season.id
                : null
            }
          />
        )}
        {/* Title */}
        <Section mt={4} mb={6}>
          <LegacyText
            as={"h1"}
            color="N800"
            fontWeight="extraBold"
            fontSize={9}
            lineHeight={"56px" as any}
          >
            {title}
          </LegacyText>
        </Section>

        <Section mb={[8, 5]}>
          <Flex justifyContent={"space-between"} style={{ gap: "65px" }}>
            <Box flex={2} minWidth={0}>
              <Divider mb={5} />
              <EventSummary event={event} />
              <Divider my={[5, 4]} />
              <EventInformation event={event} />
            </Box>
            <CTACard
              pageContext={pageContext}
              showReleaseCodes={showReleaseCodes}
            />
          </Flex>
        </Section>
        {isCompetitionPageContext(pageContext) ? (
          <CompetitionDetails
            competition={pageContext.competition}
            eventId={pageContext.event?.id}
          />
        ) : null}
      </PageContainer>
    </>
  );
};
